import { Disclosures, DisclosuresProps } from '@fcamna/react-library';
import { htmlReactParser } from '../utils/htmlReactParser';
import { TDisclosureItemAemProp } from '../model/AemDataProps';

export default function Disclosure({
  aemDisclosureProp,
  ...props
}: {
  aemDisclosureProp: TDisclosureItemAemProp;
} & DisclosuresProps) {
  return (
    <div>
      <Disclosures
        disclosureTitleColor="#4d5b6d"
        id={aemDisclosureProp.disclosure.disclosureKey}
        disclosureContent={htmlReactParser(aemDisclosureProp.disclosure.disclosureText)}
        aria-label={aemDisclosureProp.disclosure.ariaLabel}
        {...props}
      />
    </div>
  );
}
